import { getStorageItem, updateStorageItem } from 'utils/browserCache';

import { STORAGE_LOCATION, LOCAL_STORAGE_KEY } from 'constants/browserCache';
import { CvnaChatUiType } from 'utils/browserCache/types';

export const saveHideEndChatToStorage = (hideEndChatBtn: boolean) => {
  const currLocalState = getStorageItem(
    STORAGE_LOCATION.LOCAL_STORAGE,
    LOCAL_STORAGE_KEY.CVNA_CHAT_UI,
  ) as CvnaChatUiType;

  updateStorageItem(STORAGE_LOCATION.LOCAL_STORAGE, LOCAL_STORAGE_KEY.CVNA_CHAT_UI, {
    ...(currLocalState && currLocalState),
    hideEndChatBtn,
  });
};

export const saveEndChatModalTypeToStorage = (endChatModalType: string) => {
  const currLocalState = getStorageItem(
    STORAGE_LOCATION.LOCAL_STORAGE,
    LOCAL_STORAGE_KEY.CVNA_CHAT_UI,
  ) as CvnaChatUiType;

  updateStorageItem(STORAGE_LOCATION.LOCAL_STORAGE, LOCAL_STORAGE_KEY.CVNA_CHAT_UI, {
    ...(currLocalState && currLocalState),
    endChatModalType,
  });
};

export const getCachedHideEndChatBtn = () => {
  const currLocalState = getStorageItem(
    STORAGE_LOCATION.LOCAL_STORAGE,
    LOCAL_STORAGE_KEY.CVNA_CHAT_UI,
  ) as CvnaChatUiType;

  return currLocalState?.hideEndChatBtn;
};

export const getCachedEndChatModalType = () => {
  const currLocalState = getStorageItem(
    STORAGE_LOCATION.LOCAL_STORAGE,
    LOCAL_STORAGE_KEY.CVNA_CHAT_UI,
  ) as CvnaChatUiType;

  return currLocalState?.endChatModalType;
};
